export const isAuthenticated = (state) => {
  if (state.auth.auth.token) return true;
  return false;
};

export const getLoggenInToken = (state) => {
  return state.auth.auth.token || "";
};

export const getLoggedInUser = (state) => {
  return state.auth.auth.user || "";
};
